export default __webpack_public_path__ + "static/media/icon-verified.e307a49c.svg";